<template>
	<div class="p_flex header_box">
		<div class="header_center p_flex p_f_a ">
			<span class="p_m_l_20 type_size_18">题型</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select v-model="form.questionTypes"  placeholder="选择题型" @change="get">
					<el-option v-for="item in questionLists"  :disabled="forbidden" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="header_center p_flex p_f_a  ">
			<span class="p_m_l_20 type_size_18">年级</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select v-model="form.gradeTypes" placeholder="选择年级" @change="get">
					<el-option v-for="item in gradeLists" :disabled="forbidden"  :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="header_center p_flex p_f_a">
			<span class="p_m_l_20 type_size_18">学科</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select v-model="form.subjectTypes" placeholder="选择学科" @change="get">
					<el-option v-for="item in subjectLists" :disabled="forbidden"  :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="header_center p_flex p_f_a p_m_t_30">
			<span class="p_m_l_20 type_size_18">类型</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select v-model="form.genreTypes" placeholder="选择类型" @change="get">
					<el-option v-for="item in genreLists" :key="item.id" :disabled="forbidden" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>
		<div class="header_center p_flex p_f_a p_m_t_30">
			<span class="p_m_l_20 type_size_18">年份</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20">
				<el-select v-model="form.yearTypes" placeholder="选择年份" @change="get">
					<el-option v-for="item in yearLists" :disabled="forbidden" :key="item.index" :label="item.dictLabel" :value="item.dictValue"></el-option>
				</el-select>
			</div>
		</div>
		<div class="header_center p_flex p_f_a p_m_t_30">
			<span class="p_m_l_20 type_size_18">分数</span>
			<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input :disabled="forbidden" v-model="form.pointTypes" placeholder="请输入分数" @change="get"></el-input></div>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		gradeType:[Number,String],
		subjectType:[Number,String],
		postData:Object
	},
	data() {
		return {
			form: {
				questionTypes: 1, //题型
				gradeTypes: '', //年纪
				subjectTypes: '', //学科
				genreTypes: 1, //类型
				yearTypes: '', //年份
				pointTypes: '' //分数
			},
			questionLists: [], //题型
			gradeLists: [], //年纪
			subjectLists: [], // 学科
			genreLists: [
				{
					id: 1,
					name: '基础题'
				},
				{
					id: 2,
					name: '拔高题'
				},
				{
					id: 3,
					name: '综合题'
				}
			], //类型
			yearLists: [] ,//年份
			type:'',
			forbidden:false
		};
	},
	watch:{
		gradeType(nval,oval){
			if( nval != '' ){
				this.form.gradeTypes = nval
			}else{
				this.form.gradeTypes = ''
			}
		},
		subjectType(nval,oval){
			if( nval != '' ){
				this.form.subjectTypes = nval
			}else{
				this.form.subjectTypes = ''
			}
		},
		postData(navl,oval){
			this.forbidden = true
			this.form.questionTypes = navl.question_type
			this.form.gradeTypes = navl.grade
			this.form.subjectTypes = navl.subject
			this.form.genreTypes = navl.type
			this.form.yearTypes = navl.year
			this.form.pointTypes = navl.score
		}
	},
	created() {
		this.$request
			.ajax(this)
			.post('/Library/questionType')
			.then(res => {
				// console.log(res.data)
				this.questionLists = res.data;
			});
		this.$request
			.ajax(this)
			.post('/Library/grade')
			.then(res => {
				// console.log(res.data)
				this.gradeLists = res.data;
			});
		this.$request
			.ajax(this)
			.post('/api_teacher/teacher_subject')
			.then(res => {
				// console.log(res.data)
				this.subjectLists = res.data;
			});
			
	},
	mounted() {
		this.type = this.$route.query.type;
		this.yearInfo();
	},
	methods: {
		get(i) {
			var that = this.form;
			this.$emit('questionTypes', this.form);
			// if (that.questionTypes && that.gradeTypes && that.subjectTypes && that.genreTypes && that.yearTypes && that.pointTypes) {
			// 	this.$emit('questionTypes', this.form);
			// 	return;
			// }
			// if (that.questionTypes || that.gradeTypes || that.subjectTypes || that.genreTypes || that.yearTypes || that.pointTypes) {
			// 	this.$emit('questionTypes', this.form.questionTypes);
			// }
		},
		yearInfo() {
			var nfOptionsArray = new Array();
			var years = new Date().getFullYear();
			for (var i = years - 20; i <= years; i++) {
				var anOption = {};
				anOption.dictValue = i;
				anOption.dictLabel = i;
				nfOptionsArray.push(anOption);
				
			}
			this.yearLists = nfOptionsArray;
			this.form.yearTypes = years
		}
	}
};
</script>

<style lang="scss" scoped>
.header_box {
	flex-wrap: wrap;
	justify-content: space-between;
}
.header_center {
	width: 340px;
	height: 65px;
	background: #f5f5f5;
	border-radius: 10px;
}
>>> .el-input__inner {
	border: none;
	background: #f5f5f5;
	font-size: 18px;
}
>>> .el-select {
	width: 100%;
}
>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
>>> .el-select .el-input .el-select__caret {
	font-size: 18px;
	color: #000000;
}
>>> .el-select-dropdown {
	z-index: 999999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/singleHeader.vue